import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { SEARCH_DICTIONARY_PAGE_NAME } from '../../constants/service/app/searchDictionaryConstants';
import { SearchDictionaryContainer } from '../../containers/search/SearchDictionaryContainer';

/**
 * 검색 사전 페이지 (AMZUWEB-694) — 동의어 · 사용자사전 · 변경 이력.
 *
 * 동의어는 저장하면 재색인 없이 바로 고객 검색에 반영된다. 실패 지점을 「새벽 재색인」에서
 * 「저장 클릭」으로 옮기는 게 이 화면의 목적이다.
 */
const SearchDictionary = (): React.JSX.Element => (
  <PageTemplate pageName={SEARCH_DICTIONARY_PAGE_NAME.MAIN}>
    <SearchDictionaryContainer />
  </PageTemplate>
);

export default SearchDictionary;
